import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure, FETCH_TEMPLATES_REQUEST, fetchTemplatesSuccess, fetchTemplatesFailure } from '../../actions/segments/fields';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error as ErrorAction } from '../../actions/error/error';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

function* fetchAvailableFields() {
  try {
    const headers = getLocalUser();
    
    if (!headers.Authorization) {
      throw new Error('Authentication token not found');
    }
    
    const response = yield call(
      axios.get, 
      `${config.API_URL}/segment/workspace-analysis`,
      { headers }
    );
    
    yield put(fetchSuccess(response.data.data));
  } catch (error) {
    yield put(ErrorAction(error));
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

function* fetchTemplates() {
  try {
    const headers = getLocalUser();
    
    if (!headers.Authorization) {
      throw new Error('Authentication token not found');
    }
    
    const response = yield call(
      axios.get, 
      `${config.API_URL}/segment/normalization-templates`,
      { headers }
    );
    
    yield put(fetchTemplatesSuccess(response.data.data));
  } catch (error) {
    yield put(ErrorAction(error));
    yield put(fetchTemplatesFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, fetchAvailableFields);
  yield takeLatest(FETCH_TEMPLATES_REQUEST, fetchTemplates);
}

export default { watch }; 